import { login, logout, getInfo } from '../../api/user'
import { getToken, setToken, removeToken } from '../../utils/auth'
import { $themeConfig } from '@themeConfig'
import { getUserAvatar } from '@/api/user'

const state = {
  token: getToken(),
  api_token: '',
  name: '',
  avatar: '',
  introduction: '',
  role: '',
  user_info: ''
}
const apiUrl = $themeConfig.app.apiUrl

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_API_TOKEN: (state, api_token) => {
    state.api_token = api_token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },

  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },

  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_USER_INFO: (state, user_info) => {
    state.user_info = user_info
  }
}

const actions = {
  //登录
  login({ commit }, userInfo) {
    const { userName, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ userName: userName.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        commit('SET_ROLE', data.dicUserRole)
        setToken(data.token)
		console.log(data)
		let userData = {
		  fullName:data.userName,
		  avatar:apiUrl+data.photoImage,
		  role:"client",
		  ability:[{
		    action: 'read',
		    subject: 'ACL',
		  }]
		}
		if(data.dicUserRole.userRolesIdentifier==1){
			userData.role = "admin"
			userData.ability = [{
			  action: 'manage',
			  subject: 'all',	
			}]
		}
		data.userData = userData
		localStorage.setItem('userData', JSON.stringify(userData))
        resolve(response)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  //获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        //const { role, name, avatar, introduction } = data

        // role must be a non-empty array
       // if (!role || role.length <= 0) {
        //  reject('无权限访问！')
       // }

        commit('SET_NAME', data.name)
        commit('SET_EMAIL', data.email)
        commit('SET_ROLE', data.role)
        commit('SET_API_TOKEN', data.api_token)
        commit('SET_USER_INFO', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  //退出登录
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
	  removeToken()
	  resolve()
    })
  },

  //删除token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLE', '')
      commit('SET_USER_INFO', '')
      removeToken()
      resolve()
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
